import * as Actions from '../actions';

const initialState = {
	data: "All"
};

const selectedCluster = (state = initialState, action) => {

	switch (action.type) {
		// SET
		case Actions.SET_SELECTED_CLUSTER: {
			return action.payload;
		}
		// DEFAULT
		default: {
			return state;
		}
	}
};

const allCluster = (state = initialState, action) => {

	switch (action.type) {
		// SET
		case Actions.SET_ALL_CLUSTER: {
			return action.payload;
		}
		// DEFAULT
		default: {
			return state;
		}
	}
};

export  {selectedCluster, allCluster};
